import React from 'react';

const TrackingEventCard = ({ event }) => {
  return (
    <div className="operational-card">
      <div className="operational-header">
        <div>
          <strong>{event.title}</strong>
          <span className="operational-category">{event.category}</span>
        </div>
      </div>
      {event.message && (
        <div className="operational-details">
          <p>{event.message}</p>
        </div>
      )}
      <div className="operational-timestamp">
        {new Date(event.timestamp).toLocaleString('it-IT')}
      </div>
    </div>
  );
};

export default TrackingEventCard;
